import { render, staticRenderFns } from "./RegistrationFormRow.vue?vue&type=template&id=34baf1c5&scoped=true&"
import script from "./RegistrationFormRow.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormRow.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormRow.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegistrationFormRow.vue?vue&type=style&index=1&id=34baf1c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34baf1c5",
  null
  
)

export default component.exports